import { useEffect, useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import axios, { API } from "@/lib/api";

export default function FAQSection() {
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    axios.get(`${API}/public/faqs`).then(({ data }) => setFaqs(data)).catch(() => {});
  }, []);

  if (faqs.length === 0) return null;

  return (
    <section className="mx-auto max-w-4xl px-4 py-20 sm:px-6 lg:px-8" data-testid="faq-section">
      <div className="text-center">
        <span className="text-sm font-semibold uppercase tracking-wide text-[#1677B8]">FAQ</span>
        <h2 className="mt-3 font-heading text-3xl font-bold text-[#1F2937] sm:text-4xl">Pertanyaan Umum</h2>
      </div>
      <Accordion type="single" collapsible className="mt-10 space-y-3">
        {faqs.slice(0, 6).map((f, idx) => (
          <AccordionItem key={f.id} value={f.id} data-testid={`faq-item-${idx}`} className="rounded-2xl border border-slate-100 bg-white px-5 shadow-[0_2px_10px_rgba(15,107,79,0.04)]">
            <AccordionTrigger className="font-medium text-[#1F2937] hover:no-underline">{f.question}</AccordionTrigger>
            <AccordionContent className="text-sm leading-relaxed text-[#64748B]">{f.answer}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
